/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCountriesId200,
  GetApiV1LocationCountriesId401,
  GetApiV1LocationCountriesId404,
  GetApiV1LocationCountriesId500,
  GetApiV1LocationCountriesIdPathParams,
  GetApiV1LocationCountriesIdQueryResponse,
} from "../../types/locationCountryController/GetApiV1LocationCountriesId.ts";
import { countryViewModelSchema } from "../countryViewModelSchema.ts";

export const getApiV1LocationCountriesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1LocationCountriesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCountriesId200Schema = z.lazy(
  () => countryViewModelSchema,
) as unknown as ToZod<GetApiV1LocationCountriesId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCountriesId401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1LocationCountriesId404Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCountriesId500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesId500>;

export const getApiV1LocationCountriesIdQueryResponseSchema = z.lazy(
  () => getApiV1LocationCountriesId200Schema,
) as unknown as ToZod<GetApiV1LocationCountriesIdQueryResponse>;
